import React from 'react';
import {Container} from "semantic-ui-react";
import Header from "../components/homepage/header";
import Footer from "../components/homepage/footer";

const PageContainer = (props) =>
    <div>
        <Header page={props.page}/>
        <Container>
            {props.children}
        </Container>
        <Footer/>
    </div>;

export default PageContainer;
